import { Component } from '@angular/core';
import { DialogComponent, DialogService } from 'ng2-bootstrap-modal';

import { APPSVIEWLABELS } from '../../_constants/constants';
import { AgentProfile } from '../../_models/agent.profile';
import { App } from '../../_models/data.structures';
import { ConsentService } from './../../_services/consent.service';
import { GrantUpdateDialogComponent } from './grant-update/grant-update.dialog.component';

export interface AppDialogModel {
    title: string;
    app: App;
    agentprofile: AgentProfile;
    subValue: string;
    opcoValue: string;
    selectedCountry: string;
    consentService: ConsentService;
}

@Component({
    templateUrl: './app.dialog.component.html'
})

export class AppDialogComponent extends DialogComponent<AppDialogModel, string> implements AppDialogModel {
    title: string;
    subValue: string;
    opcoValue: string;
    selectedCountry: string;
    app: App;
    agentprofile: AgentProfile;
    appsviewlabels = APPSVIEWLABELS;
    consentService: ConsentService;
    ds: DialogService;
    selectedLanguage: string;

    constructor(ds: DialogService) {
        super(ds);
        this.ds = ds;
	this.selectedLanguage = localStorage.getItem('language');
    }


    UpdateSingleAppGrant() {
        this.ds.addDialog(GrantUpdateDialogComponent, {
            title: 'Grant Update Dialog',
            scopes: this.app.scopes,
            nonScopes: this.app.nonGrantedScopes,
            subValue: this.subValue,
            opcoValue: this.opcoValue,
            appId: this.app.appId,
            consentService: this.consentService
        });
        this.close();
    }

}



// WEBPACK FOOTER //
// ./src/app/details/consents/app.dialog.component.ts